<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/jala-cycle";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('jala_cycles.singular')) }},
    resourceRoute: {default: 'jala_cycles'},
    modelVariable: {default: 'cycle'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/cycles', value);
    }
  },
}
</script>
